import React from 'react'
import { Ratings } from '@notino/react-styleguide'
import { useIntl } from 'react-intl'

// styles
import * as SC from './TestimonialsSectionStyles'
import { HomePageContainer } from '../../HomePageStyles'

// components
import VisuallyHidden from '../../../../atoms/VisuallyHidden/VisuallyHidden'

// utils
import { formatRating } from '../../../../utils/helper'

// types
import { CmsHomepageData } from '../../../../types/types'

type Props = {
	cmsData: CmsHomepageData['npTestimonialsData']
}

// component
const TestimonialsSection = (props: Props) => {
	const { cmsData } = props
	const { title, testimonials } = cmsData
	const intl = useIntl()

	const hasMoreThanThreeTestimonials = testimonials.length > 3

	return (
		<section>
			<HomePageContainer>
				<SC.SectionTitle $marginBottom={'24px'} $textAlign={'center'}>
					{title}
				</SC.SectionTitle>
				<SC.Layout $hasMoreThanThreeTestimonials={hasMoreThanThreeTestimonials}>
					{testimonials.map((testimonial, index) => {
						return (
							<SC.TestimonialCard key={index}>
								<SC.TestimonialHeading>
									<VisuallyHidden>
										{intl.formatMessage(
											{
												id: 'Average rating: {rating} out of 5',
												defaultMessage: 'Average rating: {rating} out of 5'
											},
											{ rating: formatRating(intl, testimonial.rating) }
										)}
									</VisuallyHidden>
									<Ratings
										ratingId={testimonial.ratingId}
										rating={testimonial.rating}
										size={14}
										foreground={'text.highlight'}
										background={'icon.disabled'}
										aria-hidden={'true'}
									/>
									<SC.ReviewerName>{testimonial.name}</SC.ReviewerName>
								</SC.TestimonialHeading>
								<SC.TestimonialTitle>{testimonial.title}</SC.TestimonialTitle>
								<SC.TestimonialText>{testimonial.text}</SC.TestimonialText>
							</SC.TestimonialCard>
						)
					})}
				</SC.Layout>
			</HomePageContainer>
		</section>
	)
}

export default TestimonialsSection
